// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"8357637f","239":"7a76e8d2","453":"45e1646b","553":"266cd012","644":"3ce2f7b0","801":"a32de3f0"}[chunkId] + ".chunk.js";
};